export default __webpack_public_path__ + "static/media/crackers@3x.a81ba510.jpg";